import { constants as Constants } from './index';

const tick = (team: string, name: string, remainingTime: number, timestamp: number) => ({
    payload: {
        name,
        remainingTime,
        team,
        timestamp,
    },
    type: Constants.TIMER_TICK
});

const stop = (team: string) => ({
    payload: { team },
    type: Constants.TIMER_STOP
});

export default {
    stop,
    tick
};



// WEBPACK FOOTER //
// ./src/redux/modules/timer/actions.ts